import { Trans, useTranslation } from "react-i18next";
import CodeBlock from "../components/CodeBlock";

export default function ShipCard() {
  const { t } = useTranslation();

  return (
    <article>
      <h1>{t("shipCard.title")}</h1>
      <p>{t("shipCard.intro")}</p>

      <CodeBlock title="shipImage()">{`import { shipImage } from "kira-arts";

const buffer = await shipImage(leftUserId, rightUserId, {
  guildId,
  useRoleColor: true,
  percentage: 87,
  shipName: "Choco x Mel",
});`}</CodeBlock>

      <h2>{t("shipCard.optionsTitle")}</h2>
      <CodeBlock title="ShipOptions">{`percentage?: number;
message?: string;
shipName?: string;
heartColor?: string;
accentColor?: string;
borderColor?: ColorInput;
removeBorder?: boolean;
useNitroTheme?: boolean;
useRoleColor?: boolean;
customBackground?: string;
showText?: boolean;
guildId?: string;
theme?: KiraThemeName;`}</CodeBlock>

      <p>
        <Trans i18nKey="shipCard.note" components={[<code key="0" />]} />
      </p>

      <p>
        <Trans
          i18nKey="shipCard.messageNote"
          components={[<code key="0" />, <code key="1" />]}
        />
      </p>
    </article>
  );
}
